module.exports = __webpack_public_path__ + "static/Vixel Logo Cyber-c3d4c03811422458eec3799d08dfdc99.svg";